import { useMantineTheme } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import type { CSSProperties } from "react";

interface BackButtonProps {
  onClick: () => void;
  style?: CSSProperties;
}

export function BackButton({ onClick, style }: BackButtonProps) {
  const theme = useMantineTheme();

  return (
    <IconChevronLeft
      size={50}
      onClick={onClick}
      style={{
        cursor: "pointer",
        position: "absolute",
        left: 0,
        zIndex: 1,
        ...style,
      }}
      color={theme.white}
    />
  );
}
